export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/browser-server.456138d4.worker.js");
}
